import React, { useState, useContext, useRef, useEffect } from 'react'
import { BuilderContext } from '../../pages/Sandbox/components/store/store.Builder'
import styles from './EditableDescription.module.css'

const EditableDescription = ({ field }) => {
  const builderContext = useContext(BuilderContext)
  const [isEditing, setIsEditing] = useState(false)
  const divRef = useRef()

  const description_style = field.description_design
    ? { ...field.description_design }
    : {}

  useEffect(() => {
    if (isEditing) {
      divRef.current.focus()
    }
  }, [isEditing])

  const handleDescriptionChange = () => {
    const updatedField = {
      ...field,
      description: divRef.current.textContent,
      typeSelected: 'field',
    }
    console.log('updatedField', updatedField)
    builderContext.handleFieldUpdate(updatedField, true)
  }

  const handleDoubleClick = (event) => {
    setIsEditing(true)
    builderContext.setEditingText(true)
  }

  const handleClick = (event) => {
    if (event.target !== event.currentTarget) {
      return
    }
    console.log('Clic dans la description')
    try {
      builderContext.setSelectedField(
        { design: field.description_design, id: field.id },
        'description'
      )
    } catch (error) {
      console.error(
        'Error in EditableDescriptionl in setSelectedField:',
        error.message
      )
    }
  }

  const description =
    builderContext.fields.find((item) => item.id === field.id)?.description ||
    field.description

  return (
    <div
      ref={divRef}
      contentEditable={isEditing}
      style={description_style}
      className={`${styles.description} ${
        builderContext.selectedField?.id === field.id &&
        builderContext.selectedField?.typeSelected === 'description'
          ? 'selected__item'
          : ''
      }`}
      onBlur={() => {
        setIsEditing(false)
        builderContext.setEditingText(false)
        handleDescriptionChange()
        builderContext.setIsBarButtonVisible(true)
      }}
      onClick={handleClick}
      onDoubleClick={handleDoubleClick}
      suppressContentEditableWarning={true}
    >
      {description}
    </div>
  )
}

export default EditableDescription
